<template>
    <div :class="[$style.wrapper, isSearchOpened && $style.width_expand]">
        <IconButton
            size="l"
            :interfaceTarget="isSearchOpened ? 'close-search' : 'open-search'"
            :icon="icon"
            :class="$style.search_button_override"
            @click="clickHandler"
        />
        <MobileInput
            v-if="isSearchOpened"
            v-model="inputValue"
            @focus="isInitBlockVisible = false"
        />
    </div>
    <MobileResults
        v-if="isSearchOpened"
        :searchResults="searchData"
        :status
        :isInitBlockVisible
        :onClick="onItemClick"
    />
</template>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

import IconButton from '@/components/Buttons/IconButton.vue'
import type { IconNameType } from '@/components/Icon'

import MobileInput from './components/MobileInput.vue'
import MobileResults from './components/MobileResults.vue'
import { useSearch } from './composables/use-search'

const emit = defineEmits<{ open: []; close: [] }>()

const router = useRouter()
const { isSearchOpened, searchData, status, handleOpen, handleClose, inputValue, reset, onItemClick } = useSearch()

const isInitBlockVisible = ref(true)

const icon = computed<IconNameType>(() => {
    if (!isSearchOpened.value) {
        return 'search'
    }

    return isInitBlockVisible.value ? 'close' : 'chevron-left'
})

function onClose() {
    handleClose()
    emit('close')
}

function onOpen() {
    handleOpen()
    isInitBlockVisible.value = true
    emit('open')
}

function clickHandler() {
    if (!isSearchOpened.value) {
        onOpen()
    } else if (isInitBlockVisible.value) {
        onClose()
    } else {
        isInitBlockVisible.value = true
        reset()
    }
}

router.afterEach(onClose)
</script>
<style module>
.wrapper {
    display: flex;
    gap: 6px;
}

.width_expand {
    flex: 1 0 0;
    z-index: 2;
    background: linear-gradient(var(--carbon-100), transparent);
    margin-top: calc(-12px - var(--pg-safe-area-top));
    padding-top: calc(12px + var(--pg-safe-area-top));
}

.search_button_override::before {
    box-shadow: inset 0 0 0 1px var(--white-25);
}
</style>
